/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Box,
  IconButton,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
} from '@mui/material';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';

const tooltipInformation = () => {
  return (
    <Box>
      <Typography fontWeight={500} fontSize={12}>
        Definitions
      </Typography>
      <Typography fontWeight={600} fontSize={12} mt={1}>
        New Sites Prospected:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that were newly added to Backlink (Green).
      </Typography>
      <Typography fontWeight={600} fontSize={12} mt={1}>
        .gov/.edu Outreach:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites you contacted with a gov or .edu domain.
      </Typography>
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Initial Outreach:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that you contacted for the first time (includes
        New Sites Prospected).
      </Typography>
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Follow Ups:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that you contacted, again, after having not
        received a reply.
      </Typography>
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Responses Received:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that you received a response from (does not
        include &quot;Close&quot;).
      </Typography>
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Responses Sent:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that you sent a reply to (does not include
        &quot;Close&quot;).
      </Typography>{' '}
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Approves:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that you updated the status to Approve.
      </Typography>
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Opens:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that you updated the status to Open.
      </Typography>
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Closes:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that you updated the status to Close (includes
        Site, Project, and Global).
      </Typography>{' '}
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Email Opened:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of outreach emails that were opened by a contact.
      </Typography>
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Unsubscribe:{' '}
      </Typography>
      <Typography fontSize={12}>
        Total number of sites that chose to Unsubscribe from your outreach.
      </Typography>{' '}
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Out of Office:{' '}
      </Typography>
      <Typography fontSize={12}>
        Any business day that you were not working or only worked half of the
        day (i.e. Holiday, PTO, Sick Leave).
      </Typography>
      <Typography fontSize={12} fontWeight={600} mt={1}>
        Notes:{' '}
      </Typography>
      <Typography fontSize={12}>
        Text box where you may add pertinent information (Le. Worked half day,
        link rejected for &quot;XYZ reason&quot;, began outreach for Veterans,
        etc.).
      </Typography>
    </Box>
  );
};

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 450,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const WeeklyLogToolTip = () => {
  return (
    <HtmlTooltip title={tooltipInformation()}>
      <IconButton sx={{ fontSize: 20 }}>
        <HelpRoundedIcon fontSize="inherit" />
      </IconButton>
    </HtmlTooltip>
  );
};

export default WeeklyLogToolTip;
